/** Lifecycle of a Webhook_Deliveries row. */
enum WebhookDeliveryStatusEnum {
    /** Waiting for the worker (first attempt or a scheduled retry). */
    PENDING = "pending",
    /** Claimed by a worker; reclaimed if the claim goes stale. */
    PROCESSING = "processing",
    /** The endpoint answered 2xx. */
    SUCCEEDED = "succeeded",
    /** The retry budget is spent. A redelivery puts it back to pending. */
    FAILED = "failed",
    /** Dropped before delivery: the endpoint was deleted or disabled while the row was pending. */
    CANCELLED = "cancelled",
}

export default WebhookDeliveryStatusEnum;
